import { provideBrightnavAdminPlugin } from './brightnav-admin.plugin';
import { provideAdminSectionEntry } from '@brighthub/admin-contract';

/** Providers for the BrightNav administration subapp (menu + lazy routes). */
export const BrightnavAdminModule = [
  ...provideBrightnavAdminPlugin(),
  provideAdminSectionEntry({
    id: 'dev',
    title: 'Dev',
    description: 'Development tools for testing and troubleshooting BrightNav.',
    order: 100,
    routerLink: ['dev'],
  }),
];
